import { withTranslation } from "react-i18next";

import TicketList from './TicketList';

export default withTranslation(undefined, { withRef: true })(TicketList);